export const MAX_TH_LEVEL = 18

export const ROLE_LEADER = 'leader'
export const ROLE_CO_LEADER = 'coLeader'
export const ROLE_ADMIN = 'admin'
export const ROLE_CAPTAIN = 'captain'
export const ROLE_MEMBER = 'member'

export const COOKIE_TOGGLE_TYPE = 'coc-toggle-type'
export const COOKIE_AGE_VERIFIED = 'coc-age-verified'
export const COOKIE_CREATE_ACCOUNT = 'coc-create-account'
export const COOKIE_VERIFY_ACCOUNT = 'coc-verify-account'
export const COOKIE_DISCORD_OAUTH = 'coc-discord-oauth'

export const TOGGLE_TYPE_CHAMPIONSHIP = 'championship'
// Legacy single-tab value, kept for backward-compat with existing default-tab cookies.
export const TOGGLE_TYPE_THCUP = 'thcup'

// Lower town hall cups. Each level gets its own home tab/page.
export const THCUP_LEVELS = [9, 12, 15]

// Points leaderboard ids per town hall level, from the Athlos/Gfinity admin.
// TH18 is the World Championship leaderboard. Update each season.
export const LEADERBOARD_IDS = {
	9: '250c7cf4-7559-11f1-9cc0-6ae699910302',
	12: '02beae06-7559-11f1-8c6d-6ae699910302',
	15: 'ebd9914c-7558-11f1-ab42-829bf1eb2c90',
	18: 'd82c2906-5844-11f1-a49c-fe5eaffdc674',
}
export const TOGGLE_TYPE_THCUP_PREFIX = 'thcup-'
export const thcupToggleType = (level) => `${TOGGLE_TYPE_THCUP_PREFIX}${level}`

// Events that are kept `active` so hard-coded (targeted) players can load them
// via an explicit event id, but must be hidden from the general, time-based
// selectors so they never surface for everyone else. See store/event.js.
export const HIDDEN_EVENT_IDS = [
	'9b21b76a-5312-11f1-8044-b2c1dd9dfaf6', // Preseason Event
]

export const SegmentPhase = {
	OPEN_LADDER: 'OL',
	MONTHLY_QUALIFIERS: 'MQ',
	MONTHLY_FINALS: 'MF',
}

export const MatchState = {
	NEW: 'new',
	LIVE: 'live',
	FINISHED: 'finished',
	SCHEUDLED: 'scheduled',
	UPCOMING: 'new,live,scheduled',
}
